import { useContext } from 'react';
import { InstantSearchServerContext } from "../components/InstantSearchServerContext.js";
export function useInstantSearchServerContext() {
  return useContext(InstantSearchServerContext);
}